import { Component } from '@angular/core';

@Component({
  selector: 'app-tab-qa-check',
  templateUrl: './tab-qa-check.component.html',
  styleUrls: ['./tab-qa-check.component.scss']
})
export class TabQaCheckComponent {}
